import { useTranslation } from 'react-i18next';
import H1 from '../Atoms/H1';

const PageNotFound = (props) => {

    const { i18n } = useTranslation('common');

    return (
        <div className='centered'>
            <br/>
            <br/>
            <H1 className='centered'>{i18n.language === "fr" ? ("Page non trouvée") : ("Page not found")}</H1>
            <br/>
            <a href='/annuaire' className='centered'>{i18n.language === "fr" ? "Retour à l'annuaire" : "Back to directory"}</a>
            <br/>
            <br/>
        </div>
    );
};

export default PageNotFound;